export default __webpack_public_path__ + "static/media/Business_Terms_TMS.cecdd923.pdf";